// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

export const getTeams = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "teams/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getTeamsDetail = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "teams/detailed/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getTeamOperators = async (team_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `teams/${team_id}/operators/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createTeam = async (data) => {
  const endpoint = "teams/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getTeam = async (team_id) => {
  const endpoint = `teams/${team_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateTeam = async (team_id, data) => {
  const endpoint = `teams/${team_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteTeam = async (team_id) => {
  const endpoint = `teams/${team_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Team Operator Roles
export const getTeamOperatorRoles = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "teams/team-operator-roles/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createTeamOperatorRole = async (data) => {
  const endpoint = "teams/team-operator-roles/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getTeamOperatorRoleById = async (team_operators_roles_id) => {
  const endpoint = `teams/team-operator-roles/${team_operators_roles_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteTeamOperatorRoleById = async (team_operators_roles_id) => {
  const endpoint = `teams/team-operator-roles/${team_operators_roles_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateTeamOperatorRoleById = async (team_operators_roles_id, operator_id, data) => {
  const endpoint = `teams/team-operator-roles/${team_operators_roles_id}/${operator_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listSubtasksByTeamId = async (team_id, queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || `teams/${team_id}/subtasks/`;
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
